let lastSelectedModelSize = null;

document.addEventListener('DOMContentLoaded', handleModelSwitcher);

function handleModelSwitcher() {
    handleToggleModelSwitcher();
    handleImages();
}

function handleImages(selectedVariant) {
    const collage = document.querySelector('.product-media-collage');
    const collageImages = collage?.querySelectorAll('.product-media-collage .product-media-collage__item img');
    const selectedVariantSize = selectedVariant?.option1 || collage?.dataset.defaultVariantTitle;
    let filterVariantSize = selectedVariantSize;
    const modelSizeList = getModelSizeList();
    collageImages?.forEach(image => {
        const imageSize = image.getAttribute('alt')?.split('|')?.[1]?.toLocaleUpperCase().trim();
        // no model to this size
        if (!modelSizeList?.includes(filterVariantSize)) {
            filterVariantSize = lastSelectedModelSize || modelSizeList[0];
            return;
        }
        if (imageSize === filterVariantSize) {
            image.closest('.product-media-collage__item')?.classList.remove('boa-hidden-media');
            lastSelectedModelSize = selectedVariantSize;
            return;
        }
        image.closest('.product-media-collage__item')?.classList.add('boa-hidden-media');
    });
}


function handleToggleModelSwitcher() {
    const switcher = document.querySelector('.boa-model-switcher .header-toggle');
    switcher?.addEventListener('click', toggleModelList);
    const modelLinks = document.querySelector('.boa-model-switcher .model-list');
    modelLinks?.addEventListener('click', clickOnVariantSize);
}

function toggleModelList() {
    const switcher = document.querySelector('.boa-model-switcher');
    switcher.classList.toggle("open");
}

function clickOnVariantSize(e) {
    const modelLink = e.target.closest('.model-item');
    if (!modelLink) {
        return;
    }
    const size = modelLink.dataset.variantSize;
    const variantSizeInput = document.querySelector(`.option-selector__btns input[value="${size}"]`);
    variantSizeLabel = document.querySelector(`.option-selector__btns label[for="${variantSizeInput.id}"]`);
    variantSizeLabel?.click();
}

function variantChanged(selectedVariant) {
    const modelLinks = document.querySelectorAll('.boa-model-switcher .model-item');
    modelLinks?.forEach((modelLink) => {
        if (modelLink.dataset.variantId === selectedVariant.id.toString()) {
            modelLink.classList.add('click-disabled');
        }
        else {
            modelLink.classList.remove('click-disabled');
        }
    });
    handleImages(selectedVariant);
}


function getModelSizeList() {
    const modelLinks = document.querySelectorAll('.model-list .model-item');
    return Array.from(modelLinks)?.map(item => item.dataset.variantSize)
}